import React from "react"
import types from "prop-types"
import { numberDate } from "utils/dateHelpers"

const SurveyBatchSendDate = ({ sentAt }) => (
  <span>{numberDate(sentAt)}</span>
)

SurveyBatchSendDate.propTypes = {
  sentAt: types.string.isRequired,
}

export default SurveyBatchSendDate
